import { render } from "./Header.vue?vue&type=template&id=5c195fbc"
const script = {}
script.render = render

export default script